module.exports = __webpack_public_path__ + "static/img/photography-d.5f08af76.png";